'use strict';

//Setting up route
angular.module('admin').config(['$stateProvider', '$urlRouterProvider',
	function($stateProvider, $urlRouterProvider) {

	// Admin state routing
		$stateProvider
		.state('admin', {
			url: '/41s3cr3t4dm1n',
			abstract: true,
			template: '<ui-view/>'
		})
		.state('admin.listUsers', {
			url: '/users',
			controller: 'AdminListUsersController',
			templateUrl: 'modules/admin/views/list-users.client.view.html'
		})
		.state('admin.changeUserSubscription', {
			url: '/change-user-subscription/{userId:[0-9a-f]{24}}',
			controller: 'AdminChangeUserSubscriptionController',
			templateUrl: 'modules/admin/views/change-user-subscription.client.view.html'
		})
		.state('admin.userSubscriptionOverrides', {
			url: '/user-subscription-overrides/{userId:[0-9a-f]{24}}',
			controller: 'AdminUserSubscriptionOverridesController',
			templateUrl: 'modules/admin/views/user-subscription-overrides.client.view.html'
		})
		.state('admin.chargeUser', {
			url: '/charge-user/{userId:[0-9a-f]{24}}',
			controller: 'AdminChargeUserController',
			templateUrl: 'modules/admin/views/charge-user.client.view.html'
		})
		.state('admin.hisoricUserData', {
			url: '/historic-user-data/{userId:[0-9a-f]{24}}',
			controller: 'AdminHistoricUserDataController',
			templateUrl: 'modules/admin/views/historic-user-data.client.view.html'
		})
		.state('admin.userMTProfiles', {
			url: '/user-mt-profiles/{userId:[0-9a-f]{24}}',
			controller: 'AdminUserMTProfilesController',
			templateUrl: 'modules/admin/views/user-mt-profiles.client.view.html'
		});

		// Redirect automatically to users-state from abstract admin-state
		$urlRouterProvider.when('/41s3cr3t4dm1n', '/41s3cr3t4dm1n/users');
	}
]);
